var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "editable-text-wrapper",
      on: {
        click: function ($event) {
          return _setup.preventOnClick($event)
        },
        dblclick: function ($event) {
          $event.stopPropagation()
          return _setup.handleDblClick($event)
        },
      },
    },
    [
      !_setup.editMode
        ? [
            _c(
              "div",
              {
                staticClass: "editable-div user-select-none",
                attrs: { id: "editable-label" },
              },
              [
                _vm.label ? _c("span", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_setup.text || _vm.defaultText) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _vm.renameBtn && _vm.allowEditing
                  ? _c(
                      _setup.CButton,
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: _setup.tooltipOptions,
                            expression: "tooltipOptions",
                          },
                        ],
                        staticClass: "rename-btn no-drag",
                        attrs: { content: _vm.tooltip, size: "sm" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _setup.enterTitleEditMode.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "fa-solid fa-pen" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.type === "checkbox"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _setup.inputValue,
                expression: "inputValue",
              },
            ],
            ref: "editableInputRef",
            staticClass: "editable-input form-control form-control-sm",
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_setup.inputValue)
                ? _vm._i(_setup.inputValue, null) > -1
                : _setup.inputValue,
            },
            on: {
              keydown: function ($event) {
                return _setup.onTextInputKeyDown($event)
              },
              blur: _setup.onFocusLost,
              click: function ($event) {
                return $event.stopImmediatePropagation()
              },
              change: function ($event) {
                var $$a = _setup.inputValue,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_setup.inputValue = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_setup.inputValue = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _setup.inputValue = $$c
                }
              },
            },
          })
        : _vm.type === "radio"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _setup.inputValue,
                expression: "inputValue",
              },
            ],
            ref: "editableInputRef",
            staticClass: "editable-input form-control form-control-sm",
            attrs: { type: "radio" },
            domProps: { checked: _vm._q(_setup.inputValue, null) },
            on: {
              keydown: function ($event) {
                return _setup.onTextInputKeyDown($event)
              },
              blur: _setup.onFocusLost,
              click: function ($event) {
                return $event.stopImmediatePropagation()
              },
              change: function ($event) {
                _setup.inputValue = null
              },
            },
          })
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _setup.inputValue,
                expression: "inputValue",
              },
            ],
            ref: "editableInputRef",
            staticClass: "editable-input form-control form-control-sm",
            attrs: { type: _vm.type },
            domProps: { value: _setup.inputValue },
            on: {
              keydown: function ($event) {
                return _setup.onTextInputKeyDown($event)
              },
              blur: _setup.onFocusLost,
              click: function ($event) {
                return $event.stopImmediatePropagation()
              },
              input: function ($event) {
                if ($event.target.composing) return
                _setup.inputValue = $event.target.value
              },
            },
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }